"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTargetOffer = exports.getDecisionScope = exports.tryParseJSON = exports.TARGET_OFFER_MAX_WAIT_MS = exports.TARGET_OFFER_POLL_INTERVAL = void 0;
const react_1 = __importStar(require("react"));
const useAlloy_1 = require("./useAlloy");
exports.TARGET_OFFER_POLL_INTERVAL = 100;
exports.TARGET_OFFER_MAX_WAIT_MS = 3000;
const tryParseJSON = (value) => {
    if (typeof value === 'string') {
        try {
            return JSON.parse(value);
        }
        catch {
            return undefined;
        }
    }
    if (value && typeof value === 'object') {
        return value;
    }
    return undefined;
};
exports.tryParseJSON = tryParseJSON;
const getDecisionScope = (mboxName) => {
    if (!mboxName)
        return undefined;
    return mboxName;
};
exports.getDecisionScope = getDecisionScope;
function useTargetOffer(mboxName, fallbackProps, isEnabled) {
    const [offerJson, setOfferJson] = (0, react_1.useState)(null);
    const [isOfferLoading, setIsOfferLoading] = (0, react_1.useState)(false);
    const attemptsRef = react_1.default.useRef(0);
    const cancelRef = react_1.default.useRef(false);
    const timeoutRef = react_1.default.useRef(null);
    const maxAttempts = Math.ceil(exports.TARGET_OFFER_MAX_WAIT_MS / exports.TARGET_OFFER_POLL_INTERVAL);
    const decisionScope = (0, exports.getDecisionScope)(mboxName);
    const alloy = (0, useAlloy_1.useAlloy)();
    (0, react_1.useEffect)(() => {
        cancelRef.current = false;
        if (!isEnabled) {
            setOfferJson(null);
            setIsOfferLoading(false);
            return;
        }
        if (!decisionScope) {
            setOfferJson(null);
            setIsOfferLoading(false);
            return;
        }
        if (typeof alloy !== 'function')
            return;
        attemptsRef.current = 0;
        setOfferJson(null);
        setIsOfferLoading(true);
        const scheduleNext = () => {
            if (cancelRef.current)
                return;
            timeoutRef.current = setTimeout(poll, exports.TARGET_OFFER_POLL_INTERVAL);
        };
        const poll = () => {
            if (cancelRef.current)
                return;
            alloy('sendEvent', {
                renderDecisions: true,
                personalization: { decisionScopes: [decisionScope] }
            })
                .then(result => {
                const typedResult = result;
                const propositions = typedResult.propositions ?? [];
                for (const proposition of propositions) {
                    for (const item of proposition.items ?? []) {
                        const parsed = (0, exports.tryParseJSON)(item.data?.content);
                        if (parsed && Object.keys(parsed).length > 0) {
                            if (!cancelRef.current) {
                                setOfferJson(parsed);
                                setIsOfferLoading(false);
                            }
                            return;
                        }
                    }
                }
                attemptsRef.current += 1;
                if (attemptsRef.current < maxAttempts) {
                    scheduleNext();
                }
                else if (!cancelRef.current) {
                    setIsOfferLoading(false);
                }
            })
                .catch(() => {
                if (!cancelRef.current)
                    setIsOfferLoading(false);
            });
        };
        poll();
        return () => {
            cancelRef.current = true;
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
                timeoutRef.current = null;
            }
        };
    }, [decisionScope, alloy, isEnabled]);
    const isEmptyObject = offerJson && Object.keys(offerJson).length === 0;
    const effectiveProps = offerJson && !isEmptyObject ? offerJson : fallbackProps;
    return { effectiveProps, isOfferLoading };
}
exports.useTargetOffer = useTargetOffer;
